import type { StripeElementChangeEvent } from '@stripe/stripe-js';
import { useCallback, useState } from 'react';

import { useI18n } from '#/i18n/hooks/useI18n';
import type { I18nFn } from '#/i18n/types/I18nFn';

function ERROR_MESSAGES(i18n: I18nFn) {
  return {
    // Number
    incomplete_number: i18n('Your card number is incomplete.'),
    invalid_number: i18n('Your card number is invalid.'),
    // Expiry
    incomplete_expiry: i18n(`Your card's expiration date is incomplete.`),
    invalid_expiry_year: i18n(`Your card's expiration year is invalid.`),
    invalid_expiry_year_past: i18n(`Your card's expiration year has passed.`),
    // CVC
    incomplete_cvc: i18n(`Your card's security code is incomplete.`),
  };
}

type StripeFieldStatus =
  | { type: 'empty' }
  | { type: 'complete' }
  | { type: 'error'; errorMessage: string };

export function useStripeFieldStatus(): [
  StripeFieldStatus,
  (event: StripeElementChangeEvent) => void,
] {
  const { i18n } = useI18n();

  const [status, setStatus] = useState<StripeFieldStatus>({
    type: 'empty',
  });

  const onChange = useCallback(
    (event: StripeElementChangeEvent) => {
      if (event.error) {
        setStatus({
          type: 'error',
          errorMessage:
            // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            ERROR_MESSAGES(i18n)[event.error.code] ?? event.error.message,
        });
      } else if (event.complete) {
        setStatus({ type: 'complete' });
      } else {
        setStatus({ type: 'empty' });
      }
    },
    [i18n],
  );

  return [status, onChange];
}
